<div class="rating-name-wrapper">
    @if (showName) {
    <label class="m-8">{{name}}</label>
    }
    @if (ratingId === CandidateScoreRating.Hottest) {
    <img class="icon" ngSrc="/assets/images/svg/flame.svg" width="16" height="17" alt="flame.svg">
    <img class="icon" ngSrc="/assets/images/svg/flame.svg" width="16" height="17" alt="flame.svg">
    <img class="icon" ngSrc="/assets/images/svg/flame.svg" width="16" height="17" alt="flame.svg">
    }
    @if (ratingId === CandidateScoreRating.Hotter) {
    <img class="icon" ngSrc="/assets/images/svg/flame.svg" width="16" height="17" alt="flame.svg">
    <img class="icon" ngSrc="/assets/images/svg/flame.svg" width="16" height="17" alt="flame.svg">
    }
    @if (ratingId === CandidateScoreRating.Hot) {
    <img class="icon" ngSrc="/assets/images/svg/flame.svg" width="16" height="17" alt="flame.svg">
    }
    @if (ratingId === CandidateScoreRating.Marketing) {
    <img class="icon" ngSrc="/assets/images/svg/snowflake.svg" width="16" height="17" alt="snowflake.svg">
    }
</div>